module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SemiBold.bf2340c.woff";